import React, { FC } from 'react';
import useIntersection from '../../hooks/useIntersection';

interface Props {
  children: React.ReactNode;
  className?: string;
  priority?: boolean;
}

const LazyContent: FC<Props> = ({ children, className, priority = false }) => {
  const [ref, inView] = useIntersection({
    triggerOnce: true,
    rootMargin: '100px 0px',
    skip: priority,
  });

  return (
    <div className={className} ref={ref}>
      {priority || inView ? (
        children
      ) : (
        <>
          <div className="absolute inset-x-0 inset-y-0 animate-pulse h-full w-full bg-dove" />
          <noscript>{children}</noscript>
        </>
      )}
    </div>
  );
};

export default React.memo(LazyContent);
